import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import { AnalisarAlteracaoService } from "../../../services/AnalisarAlteracaoService";
import { tipoAlteracaoEnum, TiposFeriasEnum } from "../../../constants/index.js";

export default {
  name: "AnalisarAlteracao",

  components: {
    SelectField,
    PeriodoField,
    TextAreaField,
  },

  props: {
    selected: {
      required: true,
      default: [],
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    id: null,
    idAnalisarAlteracao: null,

    form: {},
    options: {},

    titulo: 'Analisar Alteração',


    loading: {
      field: false,
      btnApprove: false,
      btnRefuse: false,
    },

    justificativaDialog: false,
    justificativaRecusa: null,
  }),

  mounted() {
    this.inicializarModal()
    this.getData(this.selected.idFerias);
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.inicializarModal()
        this.getData(this.selected.idFerias);
      }
    },

  },

  computed: {
    enumTipoAlteracao() {
      return tipoAlteracaoEnum;
    }
  },

  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.titulo = 'Analisar Férias Prêmio'
      }else{
        this.titulo = 'Analisar Alteração'
      }
    },
    async getData(id) {
      this.loading.field = true;
      const response = await AnalisarAlteracaoService.getById(id);

      this.options.tipoAlteracao = [
        {
          text: response?.tipo_alteracoes?.tipo_alteracao_alterar_periodo,
          value: response?.tipo_alteracoes?.id
        }
      ];

      this.options.tiposAlteracaoMultiplos = response.entidade_tipo_alteracao?.map(el => {
        return { text: el, value: el }
      });

      this.idAnalisarAlteracao = response.id;

      this.form = {
        dataInicioAnterior: response.ferias?.data_ini,
        dataFimAnterior: response.ferias?.data_fin,
        dataInicioAlterado: response.data_inicio,
        dataFimAlterado: response.data_fim,
        tipoAlteracao: response.tipo_alteracoes?.id,
        tiposAlteracaoMultiplos: response.entidade_tipo_alteracao,
        anexo: response.caminho,
        justificativa: response.justificativa
      };

      this.loading.field = false;
    },

    openPDF(path) {
      window.open(path);
    },

    async approve(id) {
      this.loading.btnApprove = true;

      const response = this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO'] 
        ? await AnalisarAlteracaoService.aprovarAlteracao(id)
        : await AnalisarAlteracaoService.aprovarAlteracaoV2(id);

      this.loading.btnApprove = false;
      if (response) {
        this.close();
      }
    },

    async refuse(id) {
      const formData = new FormData();
      formData.append("justificativa_recusa", this.justificativaRecusa);

      this.loading.btnRefuse = true;
      const response = await AnalisarAlteracaoService.recusarAlteracao(id, formData);
      this.loading.btnRefuse = false;
      if (response) {
        this.justificativaDialog = false;
        this.close();
      }
    },

    close() {
      this.$emit("on-close");
    },
  },
};